import { FormInputState } from 'src_common/common/mobx-utils/Form';
import { action, observable, makeAutoObservable } from 'mobx';

export class SelectNativeStateOld {
    @observable isOpen: boolean = false;

    constructor(
        private readonly stateValue: FormInputState<string>,
        private readonly onChangeCB?: (value: string) => void
    ) {
        makeAutoObservable(this);
    }

    @action onChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        const value = event.target.value;

        if (this.onChangeCB !== undefined) {
            this.onChangeCB(value);
        }

        this.stateValue.setValue(value);
        this.isOpen = !this.isOpen;
    };
}
